/* global axios */
import ApiClient from '../ApiClient';

class WhatsappPersonalChannel extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  create(params) {
    return axios.post(`${this.url}channels/whatsapp_personal`, params);
  }

  update(inboxId, params) {
    return axios.patch(
      `${this.url}channels/whatsapp_personal/${inboxId}`,
      params
    );
  }

  delete(inboxId) {
    return axios.delete(`${this.url}channels/whatsapp_personal/${inboxId}`);
  }

  getInboxSessionStatus(inboxId) {
    return axios.get(
      `${this.url}channels/whatsapp_personal/${inboxId}/session_status`
    );
  }

  getQRCode(inboxId) {
    return axios.get(
      `${this.url}channels/whatsapp_personal/${inboxId}/qr_code`
    );
  }

  refreshQR(inboxId) {
    return axios.post(
      `${this.url}channels/whatsapp_personal/${inboxId}/refresh_qr`
    );
  }

  restartSession(inboxId) {
    return axios.post(
      `${this.url}channels/whatsapp_personal/${inboxId}/restart_session`
    );
  }

  getSessionStatus(accountId, inboxId, sessionId) {
    return axios.get(
      `${this.url}channels/whatsapp_personal/${inboxId}/session_status`
    );
  }

  deleteSession(accountId, inboxId, sessionId, deleteStorage = true) {
    return axios.delete(
      `${this.url}channels/whatsapp_personal/${inboxId}/delete_session`,
      {
        params: { deleteStorage }
      }
    );
  }

  startBulkSync(inboxId, syncOptions) {
    return axios.post(
      `${this.url}channels/whatsapp_personal/${inboxId}/sync_all_data`,
      syncOptions
    );
  }

  getSyncStatus(inboxId) {
    return axios.get(
      `${this.url}channels/whatsapp_personal/${inboxId}/sync_status`
    );
  }
}

export default new WhatsappPersonalChannel();
